import { Usuario } from "@/model/usuario"
import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function validateFormikFields(values: any, schema: any): any {
  const errors = schema.validate(values)
  const formattedErrors: { [key: string]: any } = {}

  Object.keys(errors).forEach((field) => {
    const currentField = errors[field]

    if (!Array.isArray(currentField)) {
      Object.keys(currentField).forEach((nestedField) => {
        if (!formattedErrors[field]) formattedErrors[field] = {}
        formattedErrors[field][nestedField] = currentField[nestedField][0]
      })
    } else {
      formattedErrors[field] = currentField[0]
    }  
  })
  return formattedErrors
}

export function canAccessComponent(perfil: string, perms: string[], usuario: Usuario): boolean {
    return (
      usuario.perfil === perfil ||
      usuario.permissoes?.some((perm) => perms.includes(perm))
    );
};

export function downloadFileFromResponse(response: any, defaultFilename = "download") {
  try {
    const fileName =
      response?.headers?.["content-disposition"]
        ?.split("filename=")[1]
        ?.replace(/"/g, "") || defaultFilename;

    const blob = new Blob([response.data]);
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();

    window.URL.revokeObjectURL(url);

    return fileName;
  } catch (error) {
    console.error("Erro ao processar download:", error);
    throw error;
  }
}
